<template>
  <div class="animated fadeIn adjsut-fa">
    <b-card v-show="showList">
      <div slot="header">List Depreciation Adjustment of Fixed Assets  
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm">Delete</b-button>
          <b-button variant="primary mr-1" @click="posting()"><i class="fa fa-paper-plane"></i> Posting</b-button>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i> Export</b-button>
          <b-button variant="primary mr-1" @click="showFilter=!showFilter"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter" class="mb-1">
        <b-col lg="6">
            <b-row>
              <b-col lg="8">
                  <b-input-group >
                    <b-input-group-prepend><label>Adjustment Date</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgldepr1" type="date" ></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgldepr2" type="date" ></b-form-input>
                  </b-input-group>
              </b-col>
                <b-col lg="4">
                  <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Adj. # &nbsp;</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.nomor" type="date" ></b-form-input>
                  </b-input-group>
                </b-col>
          </b-row>    
          <b-input-group >
            <b-input-group-prepend><label>Adjustment Description</label></b-input-group-prepend>
            <b-form-input v-model="tblData.uraian" ></b-form-input>
          </b-input-group>
              <b-row>
                <b-col lg="8">
                    <b-input-group >
                      <b-input-group-prepend><label>FA Group/Category</label></b-input-group-prepend>
                      <b-form-select v-model="tblData.catgid" :plain="true" :options="categories"></b-form-select>
                    </b-input-group>
                  </b-col>
                <b-col lg="4">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">PO # &nbsp;</span></b-input-group-prepend>
                      <b-form-input v-model="tblData.nomorpo" placeholder="Purch. Order#"></b-form-input>
                    </b-input-group>
                </b-col>
              </b-row>            
        </b-col>
        <b-col lg="6">
              <b-row no-gutters>
                <b-col lg="5">
                    <b-input-group >
                      <b-input-group-prepend><label>FA Number | Name</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.asetid" placeholder="FA Number"></b-form-input>
                    </b-input-group>
                  </b-col>
                <b-col  lg="7">
                      <b-form-input v-model="tblData.asdesc" placeholder="FA Name/Description" class="ml-1"></b-form-input>
                </b-col>
              </b-row>                      
                <b-input-group >
                  <b-input-group-prepend><label>Model/Type/Series</label></b-input-group-prepend>
                  <b-form-input v-model="tblData.asmodel" placeholder="Model/Type/Series"></b-form-input>
                  <b-form-input v-model="tblData.asserial" placeholder="Serial Number" class="ml-1"></b-form-input>
                </b-input-group>
              <b-row no-gutters>
                <b-col lg="9">
                  <b-input-group >
                    <b-input-group-prepend><label>FA Acquisition Date</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="3" >
                   <div style="text-align:right;margin-top:5px;">
                    <b-button variant="success" size="sm" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                    <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()" >Clear Filter</b-button>
                   </div>
                </b-col>
              </b-row>                      
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"        
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit" @row-clicked="rowClicked"
      >
        <template v-slot:cell(tanggal)="data">
          <div v-if="data.item.posting==0" style="background-color:yellow;">           
            {{data.item.tanggal| moment('D-MMM-YY')}} 
          </div>
          <div v-else> 
          {{data.item.tanggal| moment('D-MMM-YY')}} 
          </div>
        </template>
        <template v-slot:cell(aspurcpri)="data">
          {{data.item.aspurcpri|numFormat}}
        </template>
        <template v-slot:cell(masaB4)="data">
          <span v-if="(data.item.lamathnB4)">{{data.item.lamathnB4}} years</span>
          <span v-if="(data.item.lamablnB4)">{{data.item.lamablnB4}} months</span>
        </template>
        <template v-slot:cell(masa)="data">
          <div v-if="((data.item.lamathnB4!==data.item.lamathn) || (data.item.lamablnB4!==data.item.lamabln))" style="background-color:yellow;">           
            <span v-if="(data.item.lamathn)">{{data.item.lamathn}} years</span>
            <span v-if="(data.item.lamabln)">{{data.item.lamabln}} months</span>
          </div>
          <div v-else> 
            <span v-if="(data.item.lamathn)">{{data.item.lamathn}} years</span>
            <span v-if="(data.item.lamabln)">{{data.item.lamabln}} months</span>
          </div>
        </template>
        <template v-slot:cell(depamtadj)="data">
          {{data.item.depamtadj|numFormat('0,0.00')}}
        </template>
        <template v-slot:cell(depaccumB4)="data">
          {{data.item.depaccumB4|numFormat('0,0.00')}}
        </template>
        <template v-slot:cell(depaccum)="data">
          <div v-if="data.item.depaccumB4!==data.item.depaccum" style="background-color:yellow;">           
            {{data.item.depaccum|numFormat('0,0.00')}}
          </div>
          <div v-else> 
            {{data.item.depaccum|numFormat('0,0.00')}}
          </div>
        </template>
        <template v-slot:cell(NilaiNett)="data">
          {{data.item.NilaiNett|numFormat('0,0.00')}}
        </template>

      </b-table>
      <b-row>
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="2" >
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
          </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-card v-if="showForm">
      <div slot="header">Depreciation Adjustment Form  
        <div class="card-header-actions">
          <b-button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row >
          <b-col xl="6" >
                <b-row no-gutters >
                  <b-col lg="5" >
                    <b-input-group class="pr-1">
                        <b-input-group-prepend><label>Fixed Asset</label></b-input-group-prepend>
                        <b-form-input v-model="model.asetid" readonly></b-form-input>  
                    </b-input-group>
                  </b-col>
                  <b-col lg="7">                            
                    <b-input-group >
                        <b-form-input v-model="model.asdesc" readonly></b-form-input>                                        
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuFixedAssetShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Model/type/Series</label></b-input-group-prepend>
                        <b-form-input v-model="model.asmodel" readonly></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="2" >
                    <b-input-group >
                        <b-input-group-prepend><span class="pt-2">Year &nbsp;</span></b-input-group-prepend>
                        <b-form-input v-model="model.asyermad" readonly></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="4">                            
                    <b-input-group >
                        <b-input-group-prepend class="d-md-inline d-lg-none"><label>S/N</label></b-input-group-prepend>
                        <b-input-group-prepend class="d-md-none d-lg-inline" style="margin-top: 6px !important;"><span>S/N &nbsp;</span></b-input-group-prepend>
                        <b-form-input v-model="model.asserial"  readonly></b-form-input>
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Original Cost (LCY)</label></b-input-group-prepend>
                        <b-input-group-prepend> <span class="input-group-text" style="width:60px !important;">{{uanguser}}</span></b-input-group-prepend>
                      <my-number class="form-control text-right" disabled separator="," v-model="model.aspurcpri" :precision="2"  readonly></my-number>
                    </b-input-group>
                  </b-col>
                  <b-col lg="6">                            
                    <b-input-group >
                        <b-input-group-prepend><label>Acquisition Date</label></b-input-group-prepend>
                        <b-form-input disabled v-model="model.asdatacq" type="date"  readonly></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-input-group >
                    <b-input-group-prepend><label>Group/Category</label></b-input-group-prepend>
                    <b-form-input v-model="model.catgname" readonly></b-form-input>                                        
                </b-input-group>

                <b-row>
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Accum. Depreciation</label></b-input-group-prepend>
                        <b-input-group-prepend>
                          <span class="input-group-text" style="width:60px !important;">{{uanguser}}</span>
                        </b-input-group-prepend>
                      <my-number class="form-control text-right" separator="," v-model="model.depaccumB4" :precision="2"  disabled></my-number>
                    </b-input-group>
                  </b-col>
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Net Value Fixed Asset </label></b-input-group-prepend>
                        <b-input-group-prepend>
                          <span class="input-group-text" style="width:60px !important;">{{uanguser}}</span>
                        </b-input-group-prepend>
                      <my-number class="form-control text-right" separator="," v-model="model.NilaiNettB4" :precision="2" readonly></my-number>
                    </b-input-group>
                  </b-col>
                </b-row>
          </b-col>
          <b-col xl="6" v-show="(model.asetkey)">
              <b-row>
                  <b-col lg="6">                            
                    <b-input-group >
                        <b-input-group-prepend><label>Adjustment Date</label></b-input-group-prepend>
                        <b-form-input v-model="model.tanggal" type="date" :state="!$v.model.tanggal.$error"></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                  <b-col lg="6">                            
                    <b-input-group >
                        <b-input-group-prepend><label>Reference Document No.</label></b-input-group-prepend>
                        <b-form-input v-model="model.nomor"></b-form-input>                                        
                    </b-input-group>
                  </b-col>
              </b-row>
                <b-input-group >
                    <b-input-group-prepend><label>Adj. Description</label></b-input-group-prepend>
                    <b-form-input v-model="model.uraian" :state="!$v.model.uraian.$error"></b-form-input>                                        
                </b-input-group>
                <!-- <b-input-group >
                    <b-input-group-prepend><label>&nbsp;</label></b-input-group-prepend>
                      <b-form-radio-group class="ml-2 mt-2" v-model="model.depadjtype" name="radioAdjustment">
                        <b-form-radio value="0">Adjustment Periode</b-form-radio>
                        <b-form-radio value="1">Adjustment Value</b-form-radio>
                      </b-form-radio-group>
                </b-input-group> -->
                <!-- <b-row v-show="(model.depadjtype==0)"> -->
                <b-row>
                  <b-col lg="12" >
                    <b-input-group >
                        <b-input-group-prepend><label>Adj. Deprec. Period</label></b-input-group-prepend>
                        <b-form-input v-model="model.lamathn" type="number"  :state="!$v.model.lamathn.$error"></b-form-input>
                        <b-input-group-append>
                          <span class="input-group-text">Year</span>
                        </b-input-group-append>
                        <b-form-input  v-model="model.lamabln" type="number"  :state="!$v.model.lamabln.$error"></b-form-input>
                        <b-input-group-append>
                          <span class="input-group-text">Month</span>
                        </b-input-group-append>
                    <!-- </b-input-group>
                  </b-col>
                  <b-col lg="6" >
                    <b-input-group > -->
                        <b-input-group-prepend><span class="p-2">Period Before &nbsp;</span></b-input-group-prepend>
                        <b-form-input disabled v-model="model.lamathnB4" type="number"  ></b-form-input>
                        <b-input-group-append>
                          <span class="input-group-text">Year</span>
                        </b-input-group-append>
                        <b-form-input  disabled v-model="model.lamablnB4" type="number"  ></b-form-input>
                        <b-input-group-append>
                          <span class="input-group-text">Month</span>
                        </b-input-group-append>
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col xl="8" >
                    <b-input-group >
                        <b-input-group-prepend><label>Adj. Deprec. Accum.</label></b-input-group-prepend>
                        <b-input-group-prepend>
                          <span class="input-group-text" style="width:60px !important;">{{uanguser}}</span>
                        </b-input-group-prepend>
                      <my-number class="form-control text-right" separator=","  v-model="model.depamtadj" :precision="2" :state="!$v.model.depamtadj.$error"></my-number>
                    </b-input-group>
                  </b-col>
                </b-row>
              <div style="text-align:right;">
                <button class="btn btn-primary mr-1" @click="save()">
                  <i class="fa fa-save"></i> Save
                </button>
                <button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close</button>
              </div>

          </b-col>
        </b-row>
    </b-card>
        <b-modal v-model="lkuFixedAssetShow" size="lg" :hide-footer="true" title="List of Fixed Asset" :centered="true">
            <lku-fixedasset @click="onSelectLkuFixedAsset" outstand="1" :formdata="lkuFixedAssetData"></lku-fixedasset>
        </b-modal>    
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
      <b-modal v-model="showPostingConfirm" title="Posting Record?" :centered="true" @ok="postingData">
        <p class="mb-1">Fixed Assed Depreciation Adjustment will be APPLIED?</p>
        <p class="font-weight-bold m-0 text-danger">No Jourval Entry will made but it'will imapct on <strong>Depreciation Schedule</strong></p>
      </b-modal>
      <b-modal v-model="showUnpostConfirm" title="Un Posting Record?" :centered="true" @ok="unpostData">
        <p class="mb-1">Fixed Assed Depreciation Adjustment will be DISCARDED?</p>
        <p class="font-weight-bold m-0 text-danger">No Jourval Entry will be removed from <strong>Accounting</strong> but it'will imapct on <strong>Depreciation Schedule</strong></p>
      </b-modal>     
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>

  </div>
</template>

<style lang="scss">
 .adjust-fa {
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 140px;
            }
        }
    }   
 }
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import fa_depreciate from "../../apis/fa_depreciate";
import dropdown from "../../data/dropdown";
import myNumber from "../../components/my-number";
import lkuFixedasset from "../lookup/lkuFassetLazzy";
import { validationMixin } from "vuelidate";
import { required, minValue,numeric } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { Loading, myNumber, lkuFixedasset},
  mixins: [validationMixin],
  validations: {
        model: {
          tanggal: { required },
          uraian: { required },
          depamtadj: { required: (function() {
                if ((this.model.lamabln != this.model.lamablnB4) || (this.model.lamathn != this.model.lamathnB4))   {
                    return true;
                } else if ((this.model.depamtadj || 0)==0){
                    return false;
                } else return true;
            }) },
          lamathn: {required : (function() {
                if ((this.model.lamabln || 0) != 0) {
                    return true;
                } else if ((this.model.lamathn || 0)==0){
                    return false;
                } else return true;
            })},
          lamabln: {required : (function() {
                if ((this.model.lamathn || 0) != 0) {
                    return true;
                } else if ((this.model.lamabln || 0)==0){
                    return false;
                } else return true;
            })}
        },
  },
  data() {
    return {
      isLoading:false,
      lkuFixedAssetData:{},
      lkuFixedAssetShow: false,
      showDelConfirm: false,
      showPostingConfirm: false,
      showUnpostConfirm: false,
      showDelConfirm: false,
      showReport:false,
      reportUrl: null,
      showList:true,
      showForm:false,
      showFilter:false,
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        
        sortBy: null,
        sortDesc: false
      },
      terpilih:{tablekey:''},
      model: {tanggal:'',uraian:'', lamabln:'',lamathn:'', depamtadj:'', depadjtype:1},
      uanguser:this.$store.state.user.matauang,
      YesNoAll: dropdown.YesNoAll,
      categories:[]
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    tblFields(){
      const fields=[
          {
            key: "tanggal",
            thStyle: "width:80px",
            label: "Adjustment Date",
            sortable: true
          },
          {
            key: "nomor",
            thStyle: "width:100px",
            label: "Adjustment #",
            sortable: true
          },
          {
            key: "uraian",
            label: "Adjustment Description",
          },
          {
            key: "masaB4",
            thStyle: "width:100px",
            label: "Deprec.Periode Before",
          },
          {
            key: "masa",
            thStyle: "width:100px",
            label: "Deprec.Periode After",
          },
          {
            key: "depamtadj",
            label: "Deprec. Accumulate Adjustment",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "depaccumB4",
            label: "Deprec. Accumulate Before",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "depaccum",
            label: "Deprec. Accumulate After",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "NilaiNett",
            label: "Nett Value Asset After",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "asetid",
            thStyle: "width:100px",
            label: "FA Number",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "asdesc",
            label: "FA Name/Description",
          },
          {
            key: "aspurcpri",
            label: "Aquisition Value",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "catgname",
            label: "Category/Group",
            thStyle: "width:120px",
            sortable: true
          },

        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },

  },
  created: async function(){
      const [a] = await Promise.all([fa_depreciate.category()]) ;
        this.categories = a.reduce((newArr,item) =>{
            newArr.push(item);
            return newArr;
        },[{ value: '', text: '--- ALL ---'}]);
      // this.adjustGroups = b;
      this.model.tanggal=this.$store.state.user.tglaktif;
      // this.model.tanggal=moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').format('YYYY-MM-DD');      
  },  
  methods: {
    data: async function(ctx) {
      this.isLoading=true;
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await fa_depreciate.listadjustment(this.tblData);      
      this.isLoading=false;
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table)  this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.catgid= '';
        this.tblData.nomorpo=  '';
        this.tblData.outstand=  '';
        this.tblData.asetid=  '';
        this.tblData.asdesc=  '';
        this.tblData.asmodel=  '';
        this.tblData.asserial=  '';
        this.tblData.asuser=  '';
        this.tblData.aslocat=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.tgldepr1=  '';
        this.tblData.tgldepr2=  '';
        this.tblData.DimVal=  '';
        this.refresh();
    },
    add: function(data) {
            for (var key in this.model) {
                this.model[key] = '';
            }
          this.showList=false;
         this.showForm=true;

    },
    edit: function() {
      if (this.terpilih.tablekey) {
          if (this.terpilih.tablekey==this.model.tablekey) {
              this.showForm=true;
              this.showList=false;
          } else {
            for (var key in this.terpilih) {
                this.model[key] = this.terpilih[key];
            }
            this.model.tanggal = moment(this.terpilih.tanggal).format('YYYY-MM-DD');
              this.showForm=true;
              this.showList=false;
          }
      } else {
            toastr.warn('Please select a row that want to be Edit!');
      }
    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.model);
              console.log('model : ',this.model);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              this.model.tanggal=moment(this.model.tanggal).format('YYYY-MM-DD');
              await fa_depreciate.saveadjustment(this.model);
              this.model.tablekey='';
              this.closeFrm();    
              setTimeout(() => {
                  this.refresh();              
              }, 500);       

            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm() {
      if (this.terpilih.tablekey) {
        this.showDelConfirm = true;
      } else {
            toastr.warn('Please select a row that want to be Deleted!');
      }
    },
    deleteData: async function() {
          try {
            await fa_depreciate.removeadjustment(this.terpilih);
            this.refresh();
          } catch (error) {
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
          }
    },    
    rowClicked(record, index) {
      if (this.terpilih.tablekey==record.tablekey) {
        console.log('terpilih row click: ', this.terpilih);
        this.edit();
      } else {
        if ((this.terpilih) && (this.terpilih._rowVariant)) {
            delete this.terpilih._rowVariant;
        }
        this.terpilih = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
      }
    },
    posting: async function () {
      if (this.terpilih.tablekey) {
            if ((this.terpilih.posting || 0) == 0) {
                this.showPostingConfirm = true;
            }
            if (this.terpilih.posting == 1) {
                this.showUnpostConfirm = true;
            }
        } else {
            toastr.warn('Please select a row that want to be Posted!');
        }
    }, 
    postingData: async function(){
        this.isLoading=true;
        try {
            for (var key in this.terpilih) {
                this.model[key] = this.terpilih[key];
            }
            this.model.tanggal=moment(this.model.tanggal).format('YYYY-MM-DD');
            // this.model.begdatecat=moment(this.model.begdatecat).format('YYYY-MM-DD');
            // this.model.enddatecat=this.model.tanggal;

            await fa_depreciate.apply(this.model);
            this.terpilih.posting=1;
            // this.printjv();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    unpostData: async function(){
        this.isLoading=true;
        try {
            for (var key in this.terpilih) {
                this.model[key] = this.terpilih[key];
            }
            this.model.tanggal=moment(this.model.tanggal).format('YYYY-MM-DD');
            // this.model.begdatecat=moment(this.model.begdatecat).format('YYYY-MM-DD');
            // this.model.enddatecat=this.model.tanggal;
            await fa_depreciate.discard(this.model);
            this.terpilih.posting=0;
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await fa_depreciate.exportxlsadjust(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    onSelectLkuFixedAsset(lkuData) {
        this.lkuFixedAssetData=lkuData;
        this.lkuFixedAssetShow=false;

        this.model.asetkey = lkuData.selected.asetkey;
        this.model.asetid = lkuData.selected.asetid;
        this.model.asdesc = lkuData.selected.asdesc;
        this.model.lamathn = lkuData.selected.lamathn;
        this.model.lamabln = lkuData.selected.lamabln;
        this.model.lamathnB4 = lkuData.selected.lamathn;
        this.model.lamablnB4 = lkuData.selected.lamabln;
        this.model.NilaiNettB4 = lkuData.selected.NilaiNett;
        this.model.depaccumB4 = lkuData.selected.Penyusutan;
        this.model.catgname = lkuData.selected.catgname;
        this.model.matauang = lkuData.selected.matauang;
        this.model.asmodel = lkuData.selected.asmodel;
        this.model.asserial = lkuData.selected.asserial;
        this.model.asyermad = lkuData.selected.asyermad;
        this.model.supplierinfo = lkuData.selected.supplierinfo;
        this.model.aspurcpri = lkuData.selected.aspurcpri;
        this.model.asdatacq = moment(lkuData.selected.asdatacq).format('YYYY-MM-DD');
        this.model.tanggal= this.model.tanggal || this.$store.state.user.tglaktif;
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
